import React from 'react'
import { ReactTyped } from 'react-typed'

const Navbar = () => {
  return (
    <div>
        <h2 className='relative text-white text-2xl top-2 text-center'>
        <ReactTyped
          strings={["Welcome Back! "]}
          typeSpeed={100}
          showCursor={false}
        />
        </h2>
    </div>
  )
}

export default Navbar